function Facebook () {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.75 30H15V19.6875H11.25V15H15V11.25C15 8.1425 17.5175 5.625 20.625 5.625H24.375V10.3125H22.5C21.465 10.3125 20.625 10.215 20.625 11.25V15H25.3125L23.4375 19.6875H20.625V30H26.25C28.3175 30 30 28.3175 30 26.25V3.75C30 1.68125 28.3175 0 26.25 0H3.75C1.68125 0 0 1.68125 0 3.75V26.25C0 28.3175 1.68125 30 3.75 30Z" fill="#00094A"/>
        </svg>
        
        );
    }
    export default Facebook
    